export const RESET_CBGU = 'RESET_CBGU';
export const GET_CALCULATE_CBGU_SUCCESS = 'GET_CALCULATE_CBGU_SUCCESS';
export const TOGGLE_USER_DATA_LOADING = 'TOGGLE_USER_DATA_LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
// templates
export const SET_SEARCH_TEMPLATE_NAME = 'SET_SEARCH_TEMPLATE_NAME';
export const SET_TEMPLATES_PAGINATION_PAGE = 'SET_TEMPLATES_PAGINATION_PAGE';
export const TOGGLE_LOAD_TEMPLATES = 'TOGGLE_LOAD_TEMPLATES';
export const RESET_CHOOSED_TEMPLATE = 'RESET_CHOOSED_TEMPLATE';
export const CHANGE_TEMPLATE_DESCRIPTION = 'CHANGE_TEMPLATE_DESCRIPTION';

// complexes
export const GET_COMPLEXES_LOADING = 'GET_COMPLEXES_LOADING';
export const GET_COMPLEXES_SUCCESS = 'GET_COMPLEXES_SUCCESS';
export const GET_COMPLEXES_ERROR = 'GET_COMPLEXES_ERROR';
export const SELECT_COMPLEX = 'SELECT_COMPLEX';
export const TOGGLE_CREATE_COMPLEX_MODAL = 'TOGGLE_CREATE_COMPLEX_MODAL';
export const TOGGLE_LOADING_COMPLEX_MENU = 'TOGGLE_LOADING_COMPLEX_MENU';
export const SET_FOOD_CORSE_SELECTED_COMPLEX = 'SET_FOOD_CORSE_SELECTED_COMPLEX';
export const IS_SHOW_DELETE_POPUP = 'IS_SHOW_DELETE_POPUP';
export const IS_SHOW_DELETE_POPUP_CANCELED = 'IS_SHOW_DELETE_POPUP_CANCELED';
export const SET_COMPLEX_STATUS = 'SET_COMPLEX_STATUS';

// template generator
export const CHANGE_TEMPLATE_NAME = 'CHANGE_TEMPLATE_NAME';
export const SET_TEMPLATE_TAGS_FILTERS = 'SET_TEMPLATE_TAGS_FILTERS';
export const CHANGE_TEMPLATE_MENU_DAYS = 'CHANGE_TEMPLATE_MENU_DAYS';
export const CHANGE_TEMPLATE_SAME_DAYS_COUNT = 'CHANGE_TEMPLATE_SAME_DAYS_COUNT';
export const SET_TEMPLATE_DAY_TAB = 'SET_TEMPLATE_DAY_TAB';
export const SET_CHOSEN_TEMPLATE_EATINGS = 'SET_CHOSEN_TEMPLATE_EATINGS';
export const SET_MENU_TEMPLATE_GENERATOR = 'SET_MENU_TEMPLATE_GENERATOR';
export const SET_TEMPLATE_GENERATION_WEIGHT = 'SET_TEMPLATE_GENERATOR_WEIGHT';
export const SET_TEMPLATE_GENERATION_CALORIES = 'SET_TEMPLATE_GENERATOR_CALORIES';
export const SET_GENDER_VALUE = 'SET_GENDER_VALUE';
export const RESET_TEMPLATE_DATA = 'RESET_TEMPLATE_DATA';
export const SET_USER_CURRENT_DAY = 'SET_USER_CURRENT_DAY';
// templates comtainer on menu generator page
export const TOGGLE_LOAD_MENU_GENERATOR_TEMPLATES = 'TOGGLE_LOAD_MENU_GENERATOR_TEMPLATES';
export const GET_MENU_GENERATOR_TEMPLATES_SUCCESS = 'GET_MENU_GENERATOR_TEMPLATES_SUCCESS';
export const GET_MENU_GENERATOR_TEMPLATES_ERROR = 'GET_MENU_GENERATOR_TEMPLATES_ERROR';
export const SET_SEARCH_MENU_GENERATOR_TEMPLATE_NAME = 'SET_SEARCH_MENU_GENERATOR_TEMPLATE_NAME';
export const SET_MENU_GENERATOR_TEMPLATES_PAGINATION_PAGE =
  'SET_MENU_GENERATOR_TEMPLATES_PAGINATION_PAGE';
export const SET_MENU_GENERATOR_TEMPLATE = 'SET_MENU_GENERATOR_TEMPLATE';
export const SET_CHOSEN_EATINGS = 'SET_CHOSEN_EATINGS';
export const TOGGLE_CHANGE_THE_SAME_DAYS = 'TOGGLE_CHANGE_THE_SAME_DAYS';
export const TOGGLE_LOAD_DISHES = 'TOGGLE_LOAD_DISHES';

// confirm publish complex course

export const TOGGLE_IS_SHOW_CONFIRM_PUBLISH_COMPLEX = 'TOGGLE_IS_SHOW_CONFIRM_PUBLISH_COMPLEX';
// loader
export const LOADER_START = 'LOADER_START';
export const LOADER_FINISH = 'LOADER_FINISH';
// details for generate block
export const TOGGLE_IS_USERS_DATA_LOADING = 'TOGGLE_IS_USERS_DATA_LOADING';
// new menu block
export const SET_MENU_MENU_GENERATOR = 'SET_MENU_MENU_GENERATOR';
export const OPEN_RECIPE_MODAL = 'OPEN_RECIPE_MODAL';
export const CLOSE_RECIPE_MODAL = 'CLOSE_RECIPE_MODAL';
export const SET_MENU_LOADING = 'SET_MENU_LOADING';
export const IS_TEMPLATE_WAS_EDITED = 'IS_TEMPLATE_WAS_EDITED';

// edit / create dish popup
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_MEASURES = 'SET_MEASURES';

// getTags
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const SET_TAGS_BY_CATEGORIES = 'SET_TAGS_BY_CATEGORIES';
export const SET_CHOOSED_TEMPLATE_TAGS = 'SET_CHOOSED_TEMPLATE_TAGS';
export const SET_TEMPLATE_PARAMETERS_CATEGORIES = 'SET_TEMPLATE_PARAMETERS_CATEGORIES';

// folder
export const CLOSE_ALL_FOLDER_MODAL = 'CLOSE_ALL_FOLDER_MODAL';
export const OPEN_ALL_FOLDER_MODAL = 'OPEN_ALL_FOLDER_MODAL';
export const CLOSE_CREATE_FOLDER_MODAL = 'CLOSE_CREATE_FOLDER_MODAL';
export const OPEN_CREATE_FOLDER_MODAL = 'OPEN_CREATE_FOLDER_MODAL;';
export const SET_ALL_FOLDERS = 'GET_FOLDERS';
export const GET_ALL_FOLDERS_ERROR = 'GET_ALL_FOLDERS_ERROR';
export const IS_LOAD_FOLDER = 'IS_LOAD_FOLDER';
export const IS_LOAD_FOLDER_END = 'IS_LOAD_FOLDER_END';
export const SET_TEMPLATE_FOLDERS = 'SET_TEMPLATE_FOLDERS';
export const IS_LOAD_TEMPLATE_FOLDERS = 'IS_LOAD_TEMPLATE_FOLDERS';
export const CHANGE_FOLDER_SELECTION = 'CHANGE_FOLDER_SELECTION';
export const IS_SHOW_RECOMMENDED_TEMPLATE = 'IS_SHOW_RECOMMENDED_TEMPLATE';
export const CLOSE_RECOMMENDED_TEMPLATE = 'CLOSE_RECOMMENDED_TEMPLATE';

// unwantedFood
export const SET_UNWANTED_FOOD = 'SET_UNWANTED_FOOD';
export const SET_UNWANTED_FOOD_DAY = 'SET_UNWANTED_FOOD_DAY';

// videos

export const SET_TRAINING_VIDEOS_LIST = 'SET_TRAINING_VIDEOS_LIST';
export const SET_TRAINING_VIDEO = 'SET_TRAINING_VIDEO';
export const SET_CHOOSED_VIDEOS_TAGS = 'SET_CHOOSED_VIDEOS_TAGS';
export const SET_SUBTEMPLATE_VIDEO = 'SET_SUBTEMPLATE_VIDEO';
export const SET_ACTIVE_VIDEO = 'SET_ACTIVE_VIDEO';
export const SET_IS_VIDEO_MODAL_OPEN = 'SET_IS_VIDEO_MODAL_OPEN';
export const SET_SUBTEMPLATE_TRAINING_VIDEOS = 'SET_SUBTEMPLATE_TRAINING_VIDEOS';
export const SET_TEMPLATE_TRAINING_VIDEOS = 'SET_TEMPLATE_TRAINING_VIDEOS';
export const SET_END_LOADING_DELETE = 'SET_END_LOADING_DELETE';
export const SET_LOADING_DELETE = 'SET_LOADING_DELETE';
export const OPEN_DELETE_MODAL = 'OPEN_DELETE_MODAL';
export const CLOSE_DELETE_MODAL = 'CLOSE_DELETE_MODAL';
export const SET_TRAINING_VIDEOS_PAGE_COUNT = 'SET_TRAINING_VIDEOS_PAGE_COUNT';
export const SET_TRAINING_VIDEOS_CURRENT_PAGE = 'SET_TRAINING_VIDEOS_CURRENT_PAGE';
export const SET_SUBTEMPLATE_TRAINING_VIDEOS_PAGE_COUNT =
  'SET_SUBTEMPLATE_TRAINING_VIDEOS_PAGE_COUNT';
export const SET_SUBTEMPLATE_TRAINING_VIDEOS_CURRENT_PAGE =
  'SET_SUBTEMPLATE_TRAINING_VIDEOS_CURRENT_PAGE';
export const SET_TEMPLATE_TRAINING_VIDEOS_PAGE_COUNT = 'SET_TEMPLATE_TRAINING_VIDEOS_PAGE_COUNT';
export const SET_TEMPLATE_TRAINING_VIDEOS_CURRENT_PAGE =
  'SET_TEMPLATE_TRAINING_VIDEOS_CURRENT_PAGE';
export const SET_TRAINING_VIDEOS_LOADING = 'SET_TRAINING_VIDEOS_LOADING';
export const SET_TRAINING_VIDEOS_END_LOADING = 'SET_TRAINING_VIDEOS_END_LOADING';
export const SET_SUBTEMPLATE_TRAINING_VIDEOS_LOADING = 'SET_SUBTEMPLATE_TRAINING_VIDEOS_LOADING';
export const SET_SUBTEMPLATE_TRAINING_VIDEOS_END_LOADING =
  'SET_SUBTEMPLATE_TRAINING_VIDEOS_END_LOADING';
export const SET_LIMBERING_UP_VIDEOS_LIST = 'SET_LIMBERING_UP_VIDEOS_LIST';
export const SET_INTERRUPTION_VIDEOS_LIST = 'SET_INTERRUPTION_VIDEOS_LIST';
export const SET_SELF_DEVELOPMENT_VIDEOS_LIST = 'SET_SELF_DEVELOPMENT_VIDEOS_LIST';
export const SET_MOTIVATION_VIDEOS_LIST = 'SET_MOTIVATION_VIDEOS_LIST';
export const SET_WELCOME_VIDEOS_LIST = 'SET_WELCOME_VIDEOS_LIST';
export const SET_FAQ_VIDEOS_LIST = 'SET_FAQ_VIDEOS_LIST';
export const SET_LIMBERING_UP_VIDEOS_CURRENT_PAGE = 'SET_LIMBERING_UP_VIDEOS_CURRENT_PAGE';
export const SET_LIMBERING_UP_VIDEOS_PAGE_COUNT = 'SET_LIMBERING_UP_VIDEOS_PAGE_COUNT';
export const SET_INTERRUPTION_VIDEOS_CURRENT_PAGE = 'SET_INTERRUPTION_VIDEOS_CURRENT_PAGE';
export const SET_INTERRUPTION_VIDEOS_PAGE_COUNT = 'SET_INTERRUPTION_VIDEOS_PAGE_COUNT';
export const SET_SELF_DEVELOPMENT_VIDEOS_CURRENT_PAGE = 'SET_SELF_DEVELOPMENT_VIDEOS_CURRENT_PAGE';
export const SET_SELF_DEVELOPMENT_VIDEOS_PAGE_COUNT = 'SET_SELF_DEVELOPMENT_VIDEOS_PAGE_COUNT';
export const SET_MOTIVATION_VIDEOS_CURRENT_PAGE = 'SET_MOTIVATION_VIDEOS_CURRENT_PAGE';
export const SET_MOTIVATION_VIDEOS_PAGE_COUNT = 'SET_MOTIVATION_VIDEOS_PAGE_COUNT';
export const SET_WELCOME_VIDEOS_CURRENT_PAGE = 'SET_WELCOME_VIDEOS_CURRENT_PAGE';
export const SET_WELCOME_VIDEOS_PAGE_COUNT = 'SET_WELCOME_VIDEOS_PAGE_COUNT';
export const SET_FAQ_VIDEOS_CURRENT_PAGE = 'SET_FAQ_VIDEOS_CURRENT_PAGE';
export const SET_FAQ_VIDEOS_PAGE_COUNT = 'SET_FAQ_VIDEOS_PAGE_COUNT';
export const SET_TEMPLATE_VIDEO = 'SET_TEMPLATE_VIDEO';
export const IS_CREATE_VIDEO_LOADING = 'IS_CREATE_VIDEO_LOADING';
export const IS_CREATE_VIDEO_END_LOADING = 'IS_CREATE_VIDEO_END_LOADING';

// basket
export const SET_BASKET_DATA = 'SET_BASKET_DATA';
export const SET_IS_LOADING_BASKET_DATA = 'SET_IS_LOADING_BASKET_DATA';
export const SET_BASKET_DATES_RANGE = 'SET_BASKET_DATES_RANGE';
export const HIDE_BASKET = 'HIDE_BASKET';
export const SHOW_BASKET = 'SHOW_BASKET';

// new youslim
export const GET_NEW_YOUSLIM_TAGS = 'GET_NEW_YOUSLIM_TAGS';
export const GET_NEW_YOUSLIM_RECIPE_TAGS = 'GET_NEW_YOUSLIM_RECIPE_TAGS';
export const SET_NEW_YOUSLIM_PRODUCTS = 'SET_NEW_YOUSLIM_PRODUCTS';
export const SET_TAGS_CATEGORIES = 'SET_TAGS_CATEGORIES';
export const GET_NEW_YOUSLIM_EATING_TAGS = 'GET_NEW_YOUSLIM_EATING_TAGS';
export const SET_SEARCH_PRODUCT_LOADING_STARTED = 'SET_SEARCH_PRODUCT_LOADING_STARTED';
export const SET_SEARCH_PRODUCT_LOADING_END = 'SET_SEARCH_PRODUCT_LOADING_END';
export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT';
export const SET_CURRENT_TRAINING = 'SET_CURRENT_TRAINING';
export const SET_CURRENT_DISH = 'SET_CURRENT_DISH';
export const SET_NEW_YOUSLIM_DISH = 'SET_NEW_YOUSLIM_DISH';
export const GET_NUMBER_OF_LINKED_RECIPES = 'GET_NUMBER_OF_LINKED_RECIPES';
export const SET_GENERATOR_DATA = 'SET_GENERATOR_DATA';
export const SET_NEW_YOUSLIM_USER_TARGET = 'SET_NEW_YOUSLIM_USER_TARGET';
export const SET_NEW_YOUSLIM_USER = 'SET_NEW_YOUSLIM_USER';
export const SET_SEARCH_DISH_LOADING_STARTED = 'SET_SEARCH_DISH_LOADING_STARTED';
export const SET_TRAINING_SHOULD_DELETE = 'SET_TRAINING_SHOULD_DELETE';
export const SET_SEARCH_TRAINING_LOADING_STARTED = 'SET_SEARCH_TRAINING_LOADING_STARTED';
export const SET_SEARCH_TRAINING_LOADING_END = 'SET_SEARCH_TRAINING_LOADING_END';
export const SET_SEARCH_DISH_LOADING_END = 'SET_SEARCH_DISH_LOADING_END';
export const SET_PRODUCT_TO_FIND = 'SET_PRODUCT_TO_FIND';
export const SET_PRODUCT_LOADING = 'SET_PRODUCT_LOADING';
export const FINISH_PRODUCT_LOADING = 'FINISH_PRODUCT_LOADING';
export const SET_DISH_LOADING = 'SET_DISH_LOADING';
export const FINISH_DISH_LOADING = 'FINISH_DISH_LOADING';

export const SET_TRAINING_LOADING = 'SET_TRAINING_LOADING';
export const FINISH_TRAINING_LOADING = 'FINISH_TRAINING_LOADING';

export const SET_COMPLEXITY = 'SET_COMPLEXITY';
export const SET_TRAINING_TYPE = 'SET_TRAINING_TYPE';
export const SET_TRAINING_GEARS = 'SET_TRAINING_GEARS';

export const SET_TRAINING_TEMPLATE = 'SET_TRAINING_TEMPLATE';
export const SET_TRAINING_TEMPLATE_ID = 'SET_TRAINING_TEMPLATE_ID';

//marathon
export const SET_MARATHONS_LIST='SET_MARATHONS_LIST';
export const SET_MARATHON_DATA='SET_MARATHON_DATA';
export const SET_USER_MENU_MARATHON='SET_USER_MENU_MARATHON';

export const SET_TRAINING_COURSE = 'SET_TRAINING_COURSE';
export const SET_TRAINING = 'SET_TRAINING';
export const NEW_SET_IS_VIDEO_MODAL_OPEN = 'NEW_SET_IS_VIDEO_MODAL_OPEN';
export const NEW_SET_ACTIVE_VIDEO = 'NEW_SET_ACTIVE_VIDEO';

export const SET_USERS_LIST = 'SET_USERS_LIST';
export const SET_USERS_LIST_LOADING = 'SET_USERS_LIST_LOADING';
export const FINISH_USERS_LIST_LOADING = 'FINISH_USERS_LIST_LOADING';
export const SET_NEW_YOUSLIM_USER_INFO = 'SET_NEW_YOUSLIM_USER_INFO';
export const SET_USERS_LIST_FOR_SELECT = 'SET_USERS_LIST_FOR_SELECT';
export const SET_UPDATE_USER_START_DATE = 'SET_UPDATE_USER_START_DATE';
export const SET_UPDATE_USER_IS_PAID = 'SET_UPDATE_USER_IS_PAID';
export const SET_UPDATE_USER_STATUS_COURSE = 'SET_UPDATE_USER_STATUS_COURSE';
export const SET_UPDATE_MENU_IN_COURSE = 'SET_UPDATE_MENU_IN_COURSE';
export const SET_MEALS_TO_REPLACE_LIST = 'SET_MEALS_TO_REPLACE_LIST';
export const SET_DISH_FOR_REPLACEMENT = 'SET_DISH_FOR_REPLACEMENT';
export const SET_REPLACE_USER_MENU_DISH = 'SET_REPLACE_USER_MENU_DISH';

export const SET_CREATE_COURSE_LOADING = 'SET_CREATE_COURSE_LOADING';
export const FINISH_CREATE_COURSE_LOADING = 'FIHISH_CREATE_COURSE_LOADING';



// WEBPACK FOOTER //
// ./src/constants/constants.js